import VueWrapper from '@/components/core/Vue/vue.wrapper';
import SaveWrapperComponent from '@/components/shared/save-wrapper/save-wrapper.component';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {BackupService} from '../services/backup.service';

@Component
export default class BackupRestoreComponent extends VueWrapper {
    public $refs!: {
        saveWrapperRef: SaveWrapperComponent;
    };

    @Prop({
        type: String,
        default: () => {
            return 'backup-restore';
        },
    })
    public readonly name!: string;

    public backupSrv: BackupService = new BackupService();

    public mounted() {}

    public filesSelected(event: FileList) {
        if (event.length > 0) {
            this.backupSrv.file = event.item(0);
            console.log('Selected file for restoration:', this.backupSrv.file);
        } else {
            console.warn('No file selected for restoration.');
        }
    }

    public restoreBackup() {
        if (this.backupSrv.file) {
            this.backupSrv.restoreBackup(this.backupSrv.file);
        } else {
            console.warn('No backup file selected for restoration.');
        }
    }

    public reset() {
        this.backupSrv.file = null;
        this.backupSrv.restoreActions = [];
        this.backupSrv.isRestoreSuccessful = false;
    }
}
